import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { API_BASE_URL } from './api';

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);

  const navigate = useNavigate();

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!email || !password) {
      setErrorMessage("Both email and password are required.");
      return;
    }
  
    const data = { email, password };
  
    try {
      const response = await fetch(`${API_BASE_URL}/api/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
  
      const result = await response.json();
  
      if (result.status) {
        const { user_id, token, role } = result;
  
        // Save to localStorage
        localStorage.setItem("authToken", token);
        localStorage.setItem("userId", user_id);
  
        // Set a session expiration timestamp (2 hours from now)
        const sessionExpiration = new Date().getTime() + 8 * 60 * 60 * 1000;

        localStorage.setItem("sessionExpiration", sessionExpiration);
        navigate("/dashboard", { replace: true });
        // Redirect based on role
       
      } else {
        setErrorMessage(result.message || "Something went wrong.");
      }
    } catch (error) {
      console.error("Error during login", error);
      setErrorMessage("An error occurred. Please try again.");
    }
  };
  

  // Check session expiration and redirect
  useEffect(() => {
    const checkSessionTimeout = () => {
      const sessionExpiration = localStorage.getItem("sessionExpiration");

      if (sessionExpiration) {
        const currentTime = new Date().getTime();

        if (currentTime >= sessionExpiration) {
          // Show SweetAlert modal
          Swal.fire({
            title: "Session Timeout",
            text: "Your session has expired. Please log in again.",
            icon: "warning",
            confirmButtonText: "Login",
          }).then(() => {
            // Clear localStorage and redirect to login
            localStorage.clear();
            navigate("/", { replace: true });
          });
        }
      }
    };

    const intervalId = setInterval(checkSessionTimeout, 2 * 60 * 1000); // Check every 2 minutes
    return () => clearInterval(intervalId);
  }, [navigate]);

  return (
    <div>
      <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">
              <div className="card mb-3">
                <div className="card-body">
                  <div className="d-flex justify-content-center py-4">
                    <a href="#" className="logo d-flex align-items-center w-auto">
                      <img
                        src="https://ik.imagekit.io/realdo/saibranding/svgs/logo-svg.svg"
                        className="h-14"
                        alt=""
                      />
                    </a>
                  </div>
                  <div className=" pt-4 pb-2">
                    <h5 className="card-title text-center pb-0 fs-4">
                      Login to Your Account 
                    </h5>
                    <p className="text-center small">
                      Enter your username & password to login
                    </p>
                  </div>

                  {errorMessage && (
                    <div className="alert alert-danger" role="alert">
                      {errorMessage}
                    </div>
                  )}

                  <form
                    className="row g-3 needs-validation"
                    onSubmit={handleSubmit}
                    noValidate
                  >
                    <div className="col-12">
                      <label htmlFor="yourUsername" className="form-label">
                        Email
                      </label>
                      <div className="input-group has-validation">
                        <input
                          type="email"
                          name="email"
                          className="form-control"
                          id="yourUsername"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                        <div className="invalid-feedback">
                          Please enter your email.
                        </div>
                      </div>
                    </div>

                    <div className="col-12">
                      <label htmlFor="yourPassword" className="form-label">
                        Password
                      </label>
                      <div className="input-group">
                        <input
                          type={passwordVisible ? "text" : "password"}
                          name="password"
                          className="form-control"
                          id="yourPassword"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          required
                        />
                        <span
                          type="button"
                          className="input-group-text"
                          onClick={() => setPasswordVisible(!passwordVisible)}
                        >
                          <i
                            className={`bi ${
                              passwordVisible ? "bi-eye-slash" : "bi-eye"
                            }`}
                          />
                        </span>
                      </div>
                      <div className="invalid-feedback">
                        Please enter your password!
                      </div>
                    </div>

              
                    <div className="col-12">
                      <button
                        type="submit"
                        className="text-white bg-primary hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center"
                      >
                        Login
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LoginPage;
